(function () {
  'use strict';

  var cfgEl = document.getElementById('ls-free-gift-config');
  if (!cfgEl) return;

  var cfg;
  try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  if (!cfg || !cfg.tiers || !cfg.tiers.length) return;
  /* Dovanų kainą nuima TIK Discount Function: kol config dev_only, ji veikia tik krepšeliams su _ls_dev
     atributu, ir tik EUR. Tema dovaną gali dėti TIK tada, kai Function ją tikrai apmokės — kitaip
     pirkėjas mokėtų už „dovaną" pilną kainą (auditas 2026-09-05). Dovana taip pat turi būti iš
     DABARTINIO pool'o (Function gv sąrašas) — vakarykštė nebeapmokama. */
  var pool = {};
  (cfg.gifts1 || []).forEach(function (id) { pool[String(id)] = '1'; });
  (cfg.gifts2 || []).forEach(function (id) { pool[String(id)] = '2'; });
  function giftsLive(cart) {
    var a = cart.attributes || {};
    return !!cfg.enabled && (!cfg.dev_only || a._ls_dev === '1');
  }

  var busy = false;
  var appliedCode = null;

  function isGift(item) {
    return item.properties && item.properties._lipsell_gift;
  }

  function subtotalExclGift(cart) {
    var sum = 0;
    for (var i = 0; i < cart.items.length; i++) {
      // pakuotės/surinkimo mokesčiai (assets/ls-fees.js) į dovanų slenkstį neįskaitomi — kaip progress-bar.liquid
      if (!isGift(cart.items[i]) && cart.items[i].product_type !== 'Mokestis') sum += cart.items[i].final_line_price;
    }
    return sum;
  }

  /* Veiksmų žurnalas (CRM crm_gift_events): ką tema padarė su dovana ir ar klientas ją išėmė pats.
     Be asmens duomenų; krepšelio žetonas be ?key= dalies. Atsakymo nelaukiam, klaida nieko nestabdo.
     sessionStorage lsGiftV1/lsGiftV2 = mūsų įdėta ir dar krepšely esanti dovana: savo išėmimus
     nuimam patys, tad dingusi pažymėta dovana = išėmė klientas. */
  var LOG_URL = 'https://links.lipsell.com/crm/gift';
  function report(cart, ev, slot, vid) {
    try {
      var body = new URLSearchParams();
      body.append('d', JSON.stringify({
        e: ev, t: parseInt(slot, 10), v: vid ? String(vid) : '', s: subtotalExclGift(cart),
        cur: cart.currency || '', n: cart.items.length, k: String(cart.token || '').split('?')[0]
      }));
      var sent = false;
      try { sent = !!(navigator.sendBeacon && navigator.sendBeacon(LOG_URL, body)); } catch (e) {}
      if (!sent) fetch(LOG_URL, { method: 'POST', body: body, mode: 'no-cors', keepalive: true, credentials: 'omit' }).catch(function () {});
    } catch (e) {}
  }
  /* dovaną išėmėm MES (nukrito suma / pasenusi) — pažymim ir pamirštam, kad nepalaikytume kliento veiksmu */
  function ourRemoval(cart, ev, item) {
    var slot = item.properties._lipsell_gift === '2' ? '2' : '1';
    sessionStorage.removeItem('lsGiftV' + slot);
    report(cart, ev, slot, item.variant_id);
  }

  /* ⚠️ Dovanos kainą nuima Discount Function (lipsell-offers-discount), NE nuolaidos kodas.
     BXGY kodas (DOVANA49/79) pažymėdavo krepšelio prekes kaip savo sąlygą (prerequisite), o
     Shopify vienai eilutei leidžia tik VIENĄ prekės nuolaidą — todėl porų -10 % nuo tų eilučių
     dingdavo (2026-09-04: su dovana 3,57 € -> 0,00 €). Kodas nebetaikomas; funkcija čia palikta
     tik tam, kad būtų aišku, kodėl, ir kad rollback'as būtų vienos eilutės. */
  function applyCode(code) {
    return Promise.resolve(code);
  }

  function refresh() {
    document.dispatchEvent(new CustomEvent('cart:sync'));
    /* laiško „Į krepšelį" (ls-cross-sell.js emailAdd) dar deda prekes — perkrovimas nutrauktų; jis pats nuves į /cart */
    if (window.theme && window.theme.pageType === 'cart' && !window.__lsEmailAdd) window.location.reload();
  }

  function change(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    });
  }

  /* bando dovanas iš sąrašo eilės tvarka — OOS (422) praleidžia; grąžina įdėtą variantą arba 0 */
  function addFrom(list, slot, i) {
    if (!list || i >= list.length) return Promise.resolve(0);
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: list[i], quantity: 1, properties: { _lipsell_gift: slot } })
    }).then(function (r) {
      return r.ok ? list[i] : addFrom(list, slot, i + 1);
    });
  }

  function sync() {
    if (busy) return;
    busy = true;

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        /* dovanos, kurių Function neapmokės (ne EUR, kontrolinė grupė, ne šios dienos pool'as) — šalinam */
        var live = giftsLive(cart);
        var stale = [];
        cart.items.forEach(function (it) {
          if (isGift(it) && (!live || !pool[String(it.variant_id)])) {
            stale.push(it.key);
            ourRemoval(cart, 'stale', it);
          }
        });
        if (stale.length) {
          return stale.reduce(function (p, k) {
            return p.then(function () { return change(k, 0); });
          }, Promise.resolve()).then(function () {
            /* pasenusi dovana isimta MUSU, ne kliento - kita sync'a turi ideti siandienine (auditas 09-06) */
            sessionStorage.setItem('lsGiftTier', '0');
            busy = false;
            refresh();
          });
        }
        if (!live) { busy = false; return; }

        var sub = subtotalExclGift(cart);
        var tier = null;
        for (var i = 0; i < cfg.tiers.length; i++) {
          if (sub >= cfg.tiers[i].cents) tier = cfg.tiers[i];
        }
        var want = tier ? tier.count : 0;

        var slot1 = null, slot2 = null;
        cart.items.forEach(function (it) {
          if (!isGift(it)) return;
          if (it.properties._lipsell_gift === '2') slot2 = it; else slot1 = it;
        });

        /* mūsų įdėta dovana dingo, o kitos prekės liko — išėmė klientas. Tuščias krepšelis = apmokėjo
           arba išvalė viską — tai ne atsisakymas dovanos, tik pamirštam. */
        [['1', slot1], ['2', slot2]].forEach(function (p) {
          var vid = sessionStorage.getItem('lsGiftV' + p[0]);
          if (!vid || p[1]) return;
          sessionStorage.removeItem('lsGiftV' + p[0]);
          if (cart.items.length) report(cart, 'removed', p[0], vid);
        });

        /* dovana visada 1 vnt — antras vnt būtų pilna kaina */
        var fixQty = [];
        if (slot1 && slot1.quantity > 1) fixQty.push(slot1.key);
        if (slot2 && slot2.quantity > 1) fixQty.push(slot2.key);
        if (fixQty.length) {
          return fixQty.reduce(function (p, k) {
            return p.then(function () { return change(k, 1); });
          }, Promise.resolve()).then(function () {
            busy = false;
            refresh();
          });
        }

        /* pertekliniai — šalinam (nukrito pakopa) */
        var removals = [];
        if (want < 2 && slot2) { removals.push(slot2.key); ourRemoval(cart, 'drop', slot2); }
        if (want < 1 && slot1) { removals.push(slot1.key); ourRemoval(cart, 'drop', slot1); }
        if (removals.length) {
          return removals.reduce(function (p, k) {
            return p.then(function () { return change(k, 0); });
          }, Promise.resolve()).then(function () {
            sessionStorage.setItem('lsGiftTier', String(want));
            busy = false;
            refresh();
          });
        }

        if (!tier) {
          /* žemiau slenksčio / tuščias krepšelis (pvz. po checkout'o) — „klientas išėmė" būsena nebegalioja */
          sessionStorage.setItem('lsGiftTier', '0');
          busy = false;
          return;
        }
        applyCode(tier.code);

        var have = (slot1 ? 1 : 0) + (slot2 ? 1 : 0);
        if (have >= want) { busy = false; return; }

        var enforced = parseInt(sessionStorage.getItem('lsGiftTier') || '0', 10);
        if (enforced >= want) {
          /* šią pakopą jau buvom sukomplektavę — klientas pats išėmė, nebekišam */
          busy = false;
          return;
        }

        var added = false;
        var chain = Promise.resolve();
        function addSlot(list, slot) {
          return addFrom(list, slot, 0).then(function (vid) {
            if (!vid) { report(cart, 'nostock', slot, 0); return; }
            added = true;
            sessionStorage.setItem('lsGiftV' + slot, String(vid));
            report(cart, 'add', slot, vid);
          });
        }
        if (!slot1 && want >= 1) {
          chain = chain.then(function () { return addSlot(cfg.gifts1, '1'); });
        }
        if (!slot2 && want >= 2) {
          chain = chain.then(function () { return addSlot(cfg.gifts2, '2'); });
        }
        return chain.then(function () {
          sessionStorage.setItem('lsGiftTier', String(want));
          busy = false;
          if (added) refresh();
        });
      })
      .catch(function () { busy = false; });   /* tinklo klaida bet kur grandineje - kitas sync'as vel galimas */
  }

  document.addEventListener('DOMContentLoaded', sync);
  document.addEventListener('product:added', function () { setTimeout(sync, 300); });
  document.addEventListener('cart:rerendered', function () { setTimeout(sync, 100); });
  /* ls-cross-sell.js ka tik irase _ls_dev (dev_only vartai) - pirmas sync'as galejo praeiti dar be jo (auditas 09-06) */
  document.addEventListener('ls:attrs', function () { setTimeout(sync, 200); });
  if (document.readyState !== 'loading') sync();
})();
